export default __webpack_public_path__ + "static/media/avatar.e24650ae.svg";